import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./styles.css";
import PaginaUno from "./pages/PaginaUno";
import PaginaDos from "./pages/PaginaDos";
import Prueba from "./pages/prueba";


export default function App() {
return (
<Router>
<div className="min-h-screen flex flex-col items-center justify-center p-10">
<Routes>
<Route path="/" element={<PaginaUno />} />
<Route path="/pagina-dos" element={<PaginaDos />} />
<Route path="/prueba" element={<Prueba />} />
</Routes>
</div>
</Router>
);
}